






























































































import _ from 'lodash'
import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'
import EventBus from '@/plugins/EventBus'
import Loading from '@finx/web-repository/src/stores/Loading'
import { getSnackbarMessage } from '@/utils/common'
import ResponseApi from '@/types/interfaces/FactoryResponse'
import { AlteracaoProfissionalRepasseResponse } from '@/types/interfaces/AlteracaoProfissionalRepasse'
import buildSnackbarAlteracaoProfissional from './alteracaoProfissionalSnackbar'

@Component
export default class ComponentModalAlterarPrestador extends Vue {
  loadAlterarPrestador: boolean = false
  searchProfissional: any = ''
  profissionalName: string = ''
  loadingProfissionalFilter: boolean = false
  $refs!: { formAlterarPrestador: any }

  formAlterarPrestadorRules: any = {
    valid: true,
    profissionalExecutante: [(v: string) => !!v || 'Campo obrigatório'],
    prestadorRepasse: [(v: string) => !!v || 'Campo obrigatório'],
  }

  profissionaisDebounced = _.debounce(param => this.getFinanceiroStore.getProfissionais(param), 500)

  get loadingAlterarPrestador() { return this.loadAlterarPrestador }
  set loadingAlterarPrestador(value: boolean) { this.loadAlterarPrestador = value }

  get modalAlterarPrestador() { return this.getFinanceiroStore.modal.modalAlterarPrestador }
  set modalAlterarPrestador(value: boolean) { this.getFinanceiroStore.setModal({ name: 'modalAlterarPrestador', value }) }

  get getFinanceiroStore() {
    return getModule(FinanceiroStore, this.$store)
  }

  get profissionalExecutante() {
    return this.getFinanceiroStore.profissionalPontuacao
  }

  set profissionalExecutante(value: any) {
    this.getFinanceiroStore.setProfissionalPontuacao(value)
  }

  get selectedProfissionalExecutante(){
    return this.getFinanceiroStore.selectedProfissionalExecutante
  }

  set selectedProfissionalExecutante(value: any){
    if (value) this.getFinanceiroStore.setSelectedProfissionalExecutante(value.userId ? value.userId : value)
  }

  get prestadorRepasse() {
    return this.getFinanceiroStore.prestadorRepasse
  }

  set prestadorRepasse(value: any) {
    this.getFinanceiroStore.setPrestadorRepasse(value)
  }

  get profissionaisExecutantes() {
    return this.getFinanceiroStore.profissionaisExecutantes
  }

  get prestadoresRepasse() {
    return this.getFinanceiroStore.prestadoresRepasse
  }

  set prestadoresRepasse(value: any) {
    this.getFinanceiroStore.prestadoresRepasse = value
  }

  async saveAlterarPrestador() {
    if (this.$refs.formAlterarPrestador.validate()) {
      this.loadingAlterarPrestador = true
      const response: ResponseApi<AlteracaoProfissionalRepasseResponse> = await this.getFinanceiroStore.saveAlterarPrestador()

      if (!response.success) {
        EventBus.$emit('setSnackbar', getSnackbarMessage(response.message || 'Ocorreu um erro ao salvar!', 'error'))
        this.loadingAlterarPrestador = false
        return
      }

      this.modalAlterarPrestador = false
      EventBus.$emit('setSnackbar', buildSnackbarAlteracaoProfissional(response.data))
      this.loadingAlterarPrestador = false
    }
  }

  changeProfissionalExecutante(value: any) {
    if (value) {
      this.profissionalName = value.nome
      this.selectedProfissionalExecutante = value.userId
      this.getFinanceiroStore.setProfissionalRepasse(value.userId)
      this.getFinanceiroStore.setProfissionalPontuacao(value.userId)
      this.getFinanceiroStore.setProfissionalPontuacaoNome(value.nome)
      this.getFinanceiroStore.getPrestadoresRepasse()
    } else {
      this.profissionalName = ''
    }
  }
  
  @Watch('searchProfissional')
  async onSearchProfissionalChanged(val: string) {
    if (!val || val.length < 3){
      return
    }
    
    if(this.profissionalName === val){
      return
    }

    this.loadingProfissionalFilter = true
    
    await this.profissionaisDebounced(val)
  }

  @Watch('modalAlterarPrestador')
  onChangeModalAlterarPrestador(value: boolean) {
    if (!value) {
      this.$refs.formAlterarPrestador.resetValidation()
      this.getFinanceiroStore.clearDadosAlterarPrestador()

      const id = this.getFinanceiroStore.idForLoadItensRepasse
      this.getFinanceiroStore.getGeracaoDeRepasseItensPrestador(id)
    } else {
      if(this.getFinanceiroStore.profissionalRepasse) {
        const profissionalObj = {
          userId: this.getFinanceiroStore.profissionalRepasse,
          nome: this.getFinanceiroStore.nomeProfissionalRepasse
        }

        const prestadorObj = {
          prestadorId: this.getFinanceiroStore.prestadorId,
          nomePrestador: this.getFinanceiroStore.prestadorNome
        }

        this.getFinanceiroStore.setProfissionalPontuacao(profissionalObj.userId)
        this.getFinanceiroStore.setProfissionalPontuacaoNome(profissionalObj.nome)
        this.getFinanceiroStore.setPrestadoresRepasse([prestadorObj])
        this.getFinanceiroStore.setProfissionaisExecutantes([profissionalObj])
        this.profissionalName = profissionalObj.nome
        this.selectedProfissionalExecutante = profissionalObj.userId
        this.prestadorRepasse = prestadorObj
      }
    }
  }  

  @Watch('profissionaisExecutantes')
  onChangeProfissionaisExecutantes(value) {
    if (value) this.loadingProfissionalFilter = false
    this.$forceUpdate()
  }
}
